// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import Cache from 'i18next-localstorage-cache';

i18n
  .use(Cache)
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,

    // 将翻译按命名空间分割，每个页面或模块只加载所需的命名空间
    ns: ['common'/* , 'dashboard', 'settings' */], // 根据业务拆分
    defaultNS: 'common',

    backend: {
      // 动态加载翻译文件：根据语言和命名空间加载，例如 /locales/en-US/common.json
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },

    // 缓存设置：将翻译结果缓存到 localStorage
    cache: {
      enabled: true,
      prefix: 'i18next_res_',
      expirationTime: 7 * 24 * 60 * 60 * 1000, // 例如缓存 7 天
    },

    interpolation: {
      escapeValue: false, // React 已经安全
      format: (value, format, lng) => {
        if (format === 'number') {
          // 格式化数字，使用 Intl.NumberFormat，自动根据语言决定小数点和千位符等
          return new Intl.NumberFormat(lng, {
            useGrouping: false,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(value);
        }
        if (format === 'date') {
          // 格式化日期，使用 toLocaleDateString 自动处理语言格式
          return new Date(value).toLocaleDateString(lng);
        }
        return value;
      }
    },

    react: {
      useSuspense: true,
    }
  });

export default i18n;